import {VuexModule, Module, Mutation, Action} from 'vuex-module-decorators';
import api from '@/api';

@Module
export default class UserModule extends VuexModule {
    _regions: any = [];

    get regions() {
        return this._regions;
    }

    @Mutation
    UP_REGIONS(regions: any) {
        this._regions = regions;
    }
    @Action
    async GET_REGIONS() {
        const res = await api.getRegions();
        this.context.commit('UP_REGIONS', res.data);
    }
}
